import React, { useEffect } from 'react';
import { updateSEO } from '../utils/seo';

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    updateSEO({ title: 'Privacy Policy' });
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-24">
      <h1 className="text-5xl font-black uppercase text-black mb-12">Privacy Policy</h1>
      <div className="prose prose-lg">
        <p>PageDraft is committed to protecting your privacy. We collect minimal data necessary for core functionality.</p>
        <h3>Data Collection</h3>
        <p>We store account information (email, name) and any content you explicitly create and publish.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;